import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import ProductItem from '../../Category/ProductItem';
import Pagination from '../../../hocs/Pagination/Pagination';
import { shuffle, intersect, unique } from '../../../utils/array';
import s from './Products.scss';

const Products = ({ setup, productCache, currentPath, filteredBy, content = {}, attrs = {}, depth = false, seed = false }) => {
	if (!productCache?.[setup.market]?.[setup.pricelist] || !content) return null;

	let completeProductList = [];
	const cache = productCache[setup.market][setup.pricelist];
	const classes = [s.products];

	if (attrs.align === 'full') classes[classes.length] = s.products__alignFull;
	if (depth === 1 && attrs.align !== 'full') classes[classes.length] = s.products__top;

	if (content.individual) {
		completeProductList = [...completeProductList, ...content.individual.reduce((acc, product) => {
			if (cache?.filterArrays?.productGroup?.[product]) return [...acc, ...cache.filterArrays.productGroup[product]];
			if (cache?.products?.[product]) return [...acc, product];
			return acc;
		}, [])];
	} else if (content.category) {
		content.category.forEach((category) => {
			// Uses default en
			completeProductList = [...completeProductList, ...(cache.filterArrays.categories[category[setup.language]] ? cache.filterArrays.categories[category[setup.language]] : [])];
		});
	} else if (content.campaign) {
		content.campaign.forEach((campaign) => {
			completeProductList = [...completeProductList, ...(cache.filterArrays.campaigns[campaign.value] || [])];
		});
	} else if (content.brand) {
		content.brand.forEach((brand) => {
			completeProductList = [...completeProductList, ...cache.filterArrays.brands[brand.value]];
		});
	}

	if (seed !== false) {
		completeProductList = shuffle(completeProductList, seed);
	}
	if (content.limit !== undefined) {
		completeProductList = completeProductList.slice(0, parseInt(content.limit, 10));
	}

	const filter = content.variation;
	let productPickerFilter = [];
	let productPickerFilterType = '';
	let isFiltered = false;

	if (cache.filterArrays[filter]) {
		productPickerFilterType = filter;
		const productPickerFilterProducts = Object.keys(cache.filterArrays[filter]).reduce((acc, f) => {
			const availableProducts = intersect(completeProductList, cache.filterArrays[filter][f]);
			if (availableProducts.length > 0) acc[f] = availableProducts;
			return acc;
		}, {});

		if (Object.keys(productPickerFilterProducts).length > 0) {
			productPickerFilter = Object.keys(productPickerFilterProducts).map((f) => ({ uri: `#${filter}=${f}`, title: cache.filterDescriptions[filter][f].text || cache.filterDescriptions[filter][f] }));
		}

		if (filteredBy.length > 0) {
			const filterWith = filteredBy.filter((f) => Object.keys(f)[0] === filter).map((f) => f[filter]);

			if (filterWith.length > 0 && filterWith[0]) {
				completeProductList = filterWith[0].reduce((acc, fT) => (productPickerFilterProducts[fT] ? [...acc, ...productPickerFilterProducts[fT]] : acc), []);
				completeProductList = unique(completeProductList);
				isFiltered = filterWith[0].length;
			}
		}
	}

	return (
		<div className={classes.join(' ')}>
			<Pagination variantClasses={[`productItem__perRow_${content.perRow}`, 'pagination__productPicker']} isFiltered={isFiltered} productPickerFilter={productPickerFilter} productPickerFilterType={productPickerFilterType} ListComponent={ProductItem} list={completeProductList} cache={productCache[setup.market][setup.pricelist].products} currentPath={currentPath} currentView={content.identifier || 'Product Picker'} canonical productPicker />
		</div>
	);
};

const mapState = ({ environment, productCache, filter }, props) => ({
	setup: environment.setup,
	productCache,
	filteredBy: filter.filteredBy,
	...props,
});

export default hot(module)(connect(mapState)(Products));
